import DateFormat from '@/shared/utils/date-format';
import EnumObject from '../../enum-object.entity';

export default class ContractPlanReport {
  id: string;

  code: string;

  externalId: number;

  status: EnumObject;

  customerName: string;

  customerTradingName: string;

  createdAt: string;

  versionDate: string;

  requestDate: string;

  expirationDate: string;

  cancellationDate: string;

  lastCompetenceValue: number;

  csm: string;

  segment: string;

  leadSource: string;

  leadOrigin: string;

  seller: string;

  country: string;

  state: string;

  city: string;

  portfolio: string;

  potential: string;

  avgMonthlySales: number;

  healthScore: number;

  nps: number;

  integrationType: string;

  competingFirm: string;

  justifications: string;

  features: string;

  isExemptFine: boolean;

  exemptFineApproverName: string;

  expirationObservation: string;

  contractGroupName: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
    this.externalId = obj.externalId || 0;
    this.status = EnumObject.of(obj.status) || {};
    this.customerName = obj.customerName || '';
    this.customerTradingName = obj.customerTradingName || '';
    this.createdAt = obj.createdAt || null;
    this.versionDate = obj.versionDate || null;
    this.requestDate = obj.requestDate || null;
    this.expirationDate = obj.expirationDate || null;
    this.cancellationDate = obj.cancellationDate || null;
    this.lastCompetenceValue = obj.lastCompetenceValue || null;
    this.csm = obj.csm || '';
    this.segment = obj.segment || '';
    this.leadSource = obj.leadSource || '';
    this.leadOrigin = obj.leadOrigin || '';
    this.seller = obj.seller || '';
    this.country = obj.country || '';
    this.state = obj.state || '';
    this.city = obj.city || '';
    this.portfolio = obj.portfolio || '';
    this.potential = obj.potential || '';
    this.avgMonthlySales = obj.avgMonthlySales || null;
    this.healthScore = obj.healthScore || null;
    this.nps = obj.nps || null;
    this.integrationType = obj.integrationType || '';
    this.competingFirm = obj.competingFirm || null;
    this.justifications = obj.justifications || '';
    this.features = obj.features || '';
    this.isExemptFine = obj.isExemptFine;
    this.exemptFineApproverName = obj.exemptFineApproverName || '';
    this.expirationObservation = obj.expirationObservation || '';
    this.contractGroupName = obj.contractGroupName || '';
  }

  public static of(obj: any): ContractPlanReport {
    return new ContractPlanReport(obj || {});
  }

  public static ofList(obj: any[]): ContractPlanReport[] {
    return obj.map(this.of);
  }

  get isInactive(): boolean {
    return this.status.value === 'INACTIVE'
  }

  get isCanceled(): boolean {
    return this.status.value === 'CANCELED'
  }

  formattedDate(date: string): string {
    return date ? DateFormat.timestampToLocal(date) : '';
  }

  get createdDateFormatted(): string {
    return this.formattedDate(this.createdAt);
  }

  get versionDateFormatted(): string {
    return this.formattedDate(this.versionDate);
  }

  get requestDateFormatted(): string {
    return this.formattedDate(this.requestDate);
  }

  get cancellationDateFormatted(): string {
    return this.formattedDate(this.cancellationDate);
  }

  get expirationDateFormatted(): string {
    return this.formattedDate(this.expirationDate);
  }

  get migrateToCompetingFirmDescription() : string {
    return this.competingFirm ? `Sim - ${this.competingFirm}` : 'Não'
  }

  get exemptFineDescription() : string {
    return this.exemptFineApproverName
      ? `Sim - ${this.exemptFineApproverName}` : 'Não'
  }

  get lastCompetenceValueAsCurrency() : string {
    return this.lastCompetenceValue ? this.lastCompetenceValue.toString().replace('.', ',') : '';
  }
}
